import { ICurrentUserState } from '@app/store/modules/account'
import * as React from 'react'

export interface ISecureComponentProps {
  children: React.ReactChild | React.ReactChild[]
  brokerage?: boolean
  development?: boolean
  guest?: boolean
}

type SecureComponentProps = ISecureComponentProps & ICurrentUserState

export class SecureComponent extends React.PureComponent<SecureComponentProps> {
  public render() {
    return this.canAccess() === true ? this.props.children : null
  }

  private canAccess(): boolean {
    if (!this.props.user) {
      return false
    }

    return (
      this.props.user.permissions.isAdmin === true ||
      (this.props.brokerage === true &&
        this.props.user.permissions.isBrokerageUser) ||
      (this.props.development === true &&
        this.props.user.permissions.isDevelopmentUser) ||
      (this.props.guest === true && this.props.user.permissions.isGuest)
    )
  }
}
